const sleep = async (ms = Number.MAX_VALUE) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export default sleep;
